export default () => ({
    selectedQueryProject: null,
    selectedQuerySite: null,
    searchQueryData: {
        query: '',
    },
    searchQueryDataSites: {
        query: '',
    },
    dtpQueries: [],
    report: null
});
